export default __webpack_public_path__ + "static/media/village2_md.ff325799.jpg";